export default __webpack_public_path__ + "static/media/barra-title.90634131.svg";